import { ObjetKStatus } from '@siclop/kstone-vue'
import type { WireframeComponent } from './WireframeComponent'

/**
 * Design tokens structure
 */
export interface DesignTokens {
  colors?: {
    primary?: string
    success?: string
    warning?: string
    danger?: string
    info?: string
    text?: string
    textSecondary?: string
    textPlaceholder?: string
    border?: string
    borderLight?: string
    background?: string
    backgroundSecondary?: string
    backgroundDark?: string
  }
  spacing?: {
    xs?: number
    sm?: number
    md?: number
    lg?: number
    xl?: number
    xxl?: number
  }
  borderRadius?: {
    none?: number
    sm?: number
    md?: number
    lg?: number
    xl?: number
    full?: number
  }
  typography?: {
    fontFamily?: string
    sizes?: Record<string, number>
    weights?: Record<string, number>
    lineHeights?: Record<string, number>
  }
  shadows?: Record<string, string>
}

/**
 * Design system containing tokens and components
 */
export class DesignSystem extends ObjetKStatus {
  name: string = 'Default'
  description?: string
  organizationId: number = 0
  isDefault: boolean = false
  tokensJson: string = '{}'
  isActive: boolean = true
  components?: WireframeComponent[]

  constructor(data?: Partial<DesignSystem>) {
    super(data)
    if (data) {
      this.name = data.name ?? 'Default'
      this.description = data.description
      this.organizationId = data.organizationId ?? 0
      this.isDefault = data.isDefault ?? false
      this.tokensJson = data.tokensJson ?? '{}'
      this.isActive = data.isActive ?? true
      this.components = data.components
    }
  }

  /**
   * Parse tokensJson to DesignTokens object
   */
  get tokens(): DesignTokens {
    try {
      return JSON.parse(this.tokensJson)
    } catch {
      return {}
    }
  }

  /**
   * Set tokens from object
   */
  set tokens(value: DesignTokens) {
    this.tokensJson = JSON.stringify(value)
  }
}
